import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import type { UpdateSubPatternRequest } from '../../../../types/subPattern';
import { convertItemOverridesToSnakeCase } from '../../../../utils/pattern/subPatternConverter';
import { syncHasSubPatterns } from './syncHasSubPatterns';

/** 子パターンを更新する（#2967） */
export const updateSubPattern = async (request: UpdateSubPatternRequest): Promise<void> => {
  const variantRef = doc(db, 'patterns', request.patternId, 'sub_patterns', request.subPatternId);

  const data: Record<string, unknown> = {
    sub_pattern_name: request.subPatternName,
    description: request.description,
    item_overrides: convertItemOverridesToSnakeCase(request.itemOverrides),
    updated_at: Timestamp.now(),
    updated_by: request.userId,
    // 更新者も代理かどうかで表示が変わるため、作成時と同じく残す（#3314）
    ...(request.isProxy !== undefined && { is_proxy: request.isProxy }),
    ...(request.operatorId ? { operator_id: request.operatorId } : {}),
  };
  if (request.isActive !== undefined) {
    data.is_active = request.isActive;
  }

  await updateDoc(variantRef, data);

  // 有効/無効の切り替えで親の判定フラグが変わりうるため再評価する
  await syncHasSubPatterns(request.patternId);
};

/**
 * 子パターンの表示順をまとめて更新する（#2967）。
 * 並び替えUIから使う想定。並び順はフラグに影響しないため再評価は行わない。
 */
export const updateSubPatternsDisplayOrder = async (
  patternId: string,
  orderedVariantIds: string[],
): Promise<void> => {
  await Promise.all(
    orderedVariantIds.map((subPatternId, index) =>
      updateDoc(doc(db, 'patterns', patternId, 'sub_patterns', subPatternId), {
        display_order: index,
      }),
    ),
  );
};
